// SETTINGS V2 — "Nový PIN" handoff dialog (GP-MENU §7.3).
//
// Thin SettingsV2DialogShell consumer hosting DemoPassHandoffV2 with the pass the
// regenerate response returned. Deliberately owns NO state: the PIN lives in
// `guestPasses.lastRegeneratedPass` and the caller drops it via
// clearLastRegeneratedPass the moment this closes (Escape / backdrop / × / Back
// / "Hotovo" all route through onClose), so the digits cannot outlive the dialog.
//
// [SEC-REQ GP-5] `showSessionSurvivalNote` is passed for BOTH variants — a fresh
// PIN does not end sessions that are already signed in.
//
// Inline styles + scoped CSS-var tokens; no MUI/sx/dt/Tailwind.
import React from "react";

import useTranslation from "../../../../shared/hooks/useTranslation";
import { GuestPass } from "../../models/guestPassModels";
import SettingsV2DialogShell from "./SettingsV2DialogShell";
import DemoPassHandoffV2 from "./DemoPassHandoffV2";

export interface RegeneratePinDialogV2Props {
  open: boolean;
  /** The regenerate response (may carry `pinCode` show-once). */
  pass?: GuestPass;
  /** Chosen by the caller from the pass source — see GuestPassListV2. */
  variant: "demo" | "guest";
  onClose: () => void;
}

const RegeneratePinDialogV2: React.FC<RegeneratePinDialogV2Props> = ({
  open,
  pass,
  variant,
  onClose,
}) => {
  const { translate: t } = useTranslation("settings");

  const footer = (
    <button
      type="button"
      className="btn btn-primary"
      onClick={onClose}
      style={{ background: "var(--mod-accent)", borderColor: "var(--mod-accent)" }}
    >
      {t("guestPass.handoffDone") as string}
    </button>
  );

  return (
    <SettingsV2DialogShell
      open={open && !!pass}
      onClose={onClose}
      width={600}
      title={t("guestPass.regenTitle") as string}
      sub={t("guestPass.regenSub") as string}
      labelledById="sv2-regenerate-pin-title"
      footer={footer}
    >
      {pass ? (
        <DemoPassHandoffV2 pass={pass} variant={variant} showSessionSurvivalNote />
      ) : null}
    </SettingsV2DialogShell>
  );
};

export default RegeneratePinDialogV2;
